import PropTypes from 'prop-types';
import React from 'react';

import FluidImage from './fluidImage';

const ResImg = ({ mobile, desktop, critical = false, aspectRatio, className, maxWidth }) => {
  if (mobile?.filename === '' || mobile?.filename === undefined) {
    mobile = desktop;
  }

  let aspectRatioClass = '';
  let aspectRatioMobileClass = '';
  if (aspectRatio?.desktop === 'vertical-aspect') {
    aspectRatioClass = 'lg:aspect-[195/270]';
  }
  if (aspectRatio?.desktop === 'wide-aspect') {
    aspectRatioClass = 'lg:aspect-[190/120]';
  }
  if (aspectRatio?.desktop === 'squre-aspect') {
    aspectRatioClass = 'lg:aspect-square';
  }

  if (aspectRatio?.mobile === 'vertical-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-[195/270]';
  }
  if (aspectRatio?.mobile === 'wide-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-[190/120]';
  }
  if (aspectRatio?.mobile === 'square-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-square';
  }

  return (
    <>
      <div
        className={`cover-image pointer-events-none hidden h-full w-full lg:block ${aspectRatioClass} ${className}`}
      >
        <FluidImage
          image={desktop}
          className="h-full w-full"
          critical={critical}
          maxWidth={maxWidth}
        />
      </div>

      <div
        className={`cover-image pointer-events-none h-full w-full lg:hidden ${aspectRatioMobileClass} ${className}`}
      >
        <FluidImage
          image={mobile}
          className="h-full w-full"
          critical={critical}
          maxWidth={maxWidth}
        />
      </div>
    </>
  );
};

export default ResImg;

ResImg.propTypes = {
  desktop: PropTypes.object.isRequired,
  aspectRatio: PropTypes.object,
  mobile: PropTypes.object,
  critical: PropTypes.bool,
  className: PropTypes.string,
  maxWidth: PropTypes.number,
};

ResImg.defaultProps = {
  aspectRatio: {},
  mobile: {},
  critical: false,
  className: '',
  maxWidth: undefined,
};
